import type React from 'react';

import { FormField, FormHelp, Input, Label } from '@zillow/constellation';
import type { Section } from '../../../../models';
import { SECURITY_DEPOSIT } from '../../../../constants';

type Props = {
  value: string;
  section: Section;
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  dataTest?: string;
};

export default function SecurityDepositBankAddressInput({ dataTest, section, ...rest }: Props) {
  return (
    <FormField
      label={<Label>Bank address</Label>}
      control={<Input data-test={dataTest} {...rest} />}
      error={section.getField(SECURITY_DEPOSIT.FIELD_NAME.BANK_ADDRESS).hasError}
      description={
        <FormHelp>
          {section.getField(SECURITY_DEPOSIT.FIELD_NAME.BANK_ADDRESS).hasError
            ? `Enter a valid address`
            : `Street, city, state, ZIP Code`}
        </FormHelp>
      }
    />
  );
}
